import { render, staticRenderFns } from "./requestFrom.vue?vue&type=template&id=2c068228&scoped=true"
import script from "./requestFrom.vue?vue&type=script&lang=js"
export * from "./requestFrom.vue?vue&type=script&lang=js"
import style0 from "./requestFrom.vue?vue&type=style&index=0&id=2c068228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c068228",
  null
  
)

export default component.exports